import { Slide } from '@/types/slide';
import { gql } from '@apollo/client';

export interface UpdateSlidesResponse {
    updateSlides: Slide[];
}

export interface UpdateSlidesVariables {
    data: {
        where: {
            id: string;
        };
        data: {
            data?: string;
            sort?: number;
        };
    }[];
}

export const UPDATE_SLIDES = gql`
    mutation UpdateSlides($data: [SlideUpdateArgs!]!) {
        updateSlides(data: $data) {
            id
            data
        }
    }
`;

export interface CreateSlidesResponse {
    createSlides: Slide[];
}

export interface CreateSlidesVariables {
    data: {
        lessonVersion: { connect: { id: string } };
        data: string;
        sort?: number;
        files?: { connect: { id: string }[] };
        images?: { connect: { id: string }[] };
    }[];
}

export const CREATE_SLIDES = gql`
    mutation CreateSlides($data: [SlideCreateInput!]!) {
        createSlides(data: $data) {
            id
            sort
            data
            questionCount
        }
    }
`;

export interface DeleteSlideResponse {
    deleteSlide: Pick<Slide, 'id'>;
}

export interface DeleteSlideVariables {
    slideID: string;
}

export const DELETE_SLIDE = gql`
    mutation delete($slideID: ID!) {
        deleteSlide(where: { id: $slideID }) {
            id
        }
    }
`;

export interface CreateSlideImageResponse {
    createSlideImage: { id: string; file: { url: string } };
}

export interface CreateSlideImageVariables {
    slideId: string;
    file: File;
}

export const CREATE_SLIDE_IMAGE = gql`
    mutation uploadImage($slideId: ID!, $file: Upload!) {
        createSlideImage(data: { file: { upload: $file }, slides: { connect: [{ id: $slideId }] } }) {
            id
            file {
                url
            }
        }
    }
`;

export interface CreateSlideFileResponse {
    createSlideFile: { id: string; file: { filename: string; url: string } };
}

export interface CreateSlideFileVariables {
    data: {
        file: {
            upload: File;
        };
        slides?: {
            connect: {
                id: string;
            }[];
        };
    };
}

export const CREATE_SLIDE_FILE = gql`
    mutation CreateSlideFile($data: SlideFileCreateInput!) {
        createSlideFile(data: $data) {
            id
            file {
                filename
                url
            }
        }
    }
`;

export interface GetSlideFilesResponse {
    slideFiles: { id: string }[];
}

export const GET_SLIDE_FILES = gql`
    query SlideFiles($where: SlideFileWhereInput!) {
        slideFiles(where: $where) {
            id
        }
    }
`;
export interface GetSlideImagesResponse {
    slideImages: { id: string }[];
}

export const GET_SLIDE_IMAGES = gql`
    query SlideImages($where: SlideImageWhereInput!) {
        slideImages(where: $where) {
            id
        }
    }
`;
